import { Component, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'cmp-table-with-checkbox',
  templateUrl: './table-with-checkbox.component.html',
  styleUrls: ['./table-with-checkbox.component.scss']
})
export class CmpTableWithCheckboxComponent {

  protected itemSelected: any;
  otherText: string = '';

  @Input() arrayItems: Array<any> = [];
  @Input() height: string = '';
  @Input() width: string = '';

  @Output() itemChecked = new EventEmitter<any>();
  @Output() itemSelectedBold = new EventEmitter<any>();
  @Output() newOthers = new EventEmitter<any>();

  constructor(
    private cd: ChangeDetectorRef) {
  }

  ngAfterViewInit() {
    this.cd.detectChanges();
  }

  seeItemSelected(item: any) {

    this.itemSelected = item;
    this.itemSelectedBold.emit(item);
  }

  checkedItem(item: any) {

    this.itemSelected = item;
    this.itemChecked.emit(item);
  }

  fillText(event:any, item: any) {
    this.otherText = event.target.value;
  }

  onEnter(item: any) {
    item.item = this.otherText;
    this.arrayItems.push({
      item: '',
      selected: true,
      type: 'outros',
    });
  }

  onTabClick(event: KeyboardEvent) {

    if (event.key === 'Tab') {

      this.newOthers.emit(this.otherText);
    }
  }

  applyStyle() {

    return { width: this.width, height: this.height };
  }

}
